module.exports = __webpack_public_path__ + "static/media/tier-1.d8a8f9ca.jpg";